// Lightweight analytics layer for WhatsApp conversion tracking.
// GA4 (gtag) and GTM (dataLayer) compatible — fires the moment a GA/GTM
// snippet is added to index.html. No-ops safely until then.

export function trackWhatsAppClick({ section, buttonName }) {
    if (typeof window === "undefined") return;

    const payload = {
        event: "whatsapp_click",
        page: window.location.pathname || "/",
        section,
        button_name: buttonName,
        timestamp: new Date().toISOString(),
    };

    // GTM dataLayer
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);

    // GA4 gtag
    if (typeof window.gtag === "function") {
        window.gtag("event", "whatsapp_click", {
            page: payload.page,
            section: payload.section,
            button_name: payload.button_name,
            timestamp: payload.timestamp,
        });
    }
}
